import classNames from "classnames";
import {useState} from "react";
import {FaArrowRight} from "react-icons/fa6";
import {Link} from "react-router";

import {Service} from "@/lib/types/checks.ts";

export const CheckUsedInRow = ({service}: {service: Service}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={"d-grid"}
      style={{gridTemplateColumns: "1fr 125px"}}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={classNames("text-break", {"fw-bold": isHover})}>
        {service.name ? service.name : service.device.address}
      </div>
      {isHover && (
        <Link
          to={`/checks/${service.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`ms-auto text-decoration-underline-hover align-content-center`}
        >
          Go to Check <FaArrowRight />
        </Link>
      )}
    </div>
  );
};
